export default {"src":"/_next/static/media/github_logo.e6db92af.svg","height":20,"width":20};